import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/ecommerce/products/${resource.id}/edit`} />
  ]
}

export default buildMenuItems
